import apiWithCache from '@/api/requests'
import auth from '@/api/auth'
import cache from '@/api/cache'

const apiService = {
  ...apiWithCache,
  auth,
  cache,

  invalidateCache(urlPattern) {
    if (typeof urlPattern === 'string') {
      cache.invalidate(urlPattern)
    } else if (urlPattern instanceof RegExp) {
      const keys = Array.from(cache.data.keys())
      keys.forEach((key) => {
        if (urlPattern.test(key)) {
          cache.invalidate(key)
        }
      })
    }
  },
}

export default apiService
